import Color from '@/tool/color';
import { Button, Checkbox, InputBase, LinearProgress } from '@mui/material';
import { styled } from '@mui/system';

const PrevButton = styled(Button)(() => ({
  minWidth: '76px',
  height: '36px',
  borderRadius: '5px',
  background: Color.fff,
  padding: '0 10px',
  border: `1px solid ${Color.ec}`,
  color: Color.c55,
  marginRight: '20px',
  '& svg': {
    marginLeft: '10px',
  },
}));

const NextButton = styled(Button)(() => ({
  minWidth: '104px',
  height: '36px',
  borderRadius: '5px',
  background: Color.primaryColor(1),
  // display: 'flex',
  // justifyContent: 'space-between',
  padding: '0 10px',
  color: Color.white,
  marginRight: '20px',
  '&:hover': {
    backgroundColor: Color.primaryColor(1),
  },
  '& svg': {
    marginLeft: '10px',
  },
  '&.Mui-disabled': {
    backgroundColor: Color.primaryColor(0.1),
    cursor: 'not-allowed',
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '70px',
  height: 4,
  borderRadius: 2,
  backgroundColor: Color.ec,
  '& .MuiLinearProgress-bar': {
    backgroundColor: Color.secondary,
  },
}));

const DefaultLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '100%',
  height: 10,
  borderRadius: 2,
  backgroundColor: Color.f7,
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#EDEFF6',
  },
}));

const ActiveLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: '100%',
  height: 10,
  borderRadius: 2,
  backgroundColor: Color.f7,
  '& .MuiLinearProgress-bar': {
    backgroundColor: Color.primary,
  },
}));

const DInput = styled(InputBase)(() => ({
  border: 0,
  width: '100%',
  height: 36,
  background: Color.whiteColor(1),
  color: Color.primary,
  fontWeight: 600,
}));

const DCheckbox = styled(Checkbox)(() => ({
  padding: 0,
  marginRight: '6px',
}));

export {
  PrevButton, NextButton, BorderLinearProgress, DefaultLinearProgress, ActiveLinearProgress, DInput, DCheckbox,
};
